import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Confirmation from '../Confirmation'
import {
  DialogActions,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  FormHelperText,
  TableRow,
  TableHead,
  Select,
  FormControl,
  MenuItem,
  TextareaAutosize,
  Typography,
  Grid,
  InputLabel,
} from '@mui/material'
import { useDispatch } from 'react-redux'
import { handleOpenAlert } from '../../../../lib/handleAlert'
import { closePopup } from '../../../../store/popupsSlice'
import { refreshFilter } from '../../../../lib/handleFilters'
import { Box } from '@mui/system'
import LoadingButton from '@mui/lab/LoadingButton'

// eslint-disable-next-line
const EventsFactory = ({ startFiles,eventsCount, data, examinations, allFiles }) => {
  const dispatch = useDispatch()

  const [files, setFiles] = useState()
  const [sweetAlert, setSweetAlert] = useState(false)
  const [validate, setValidate] = useState(false)
  const [comments, setComments] = useState([])
  const [examinationByTypeId, setExaminationByTypeId] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(async () => {
    await setContractTypes(await loadContractTypes())
    await setDefaultValues()
    const el = document.getElementById('events-factory-table')
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    // setTimeout(setFiles, 100)
    // setFiles()
  }, [])
  useEffect(async () => {
    // await setContractTypes(await loadContractTypes())
    // await setDefaultValues()
    // setTimeout(setFiles, 100)
    setFilesWithAutocomplete()
  }, [examinationByTypeId])

  const parseFilesToSend = (files) => {
    let result = {}
    for (let i = 0; i < comments.length; i++) {
      if (comments[i]) {
        result[i] = {
          comment: comments[i],
          files: [],
        }
      }
    }
    for (let i = 0; i < files.length; i++) {
      if (!result[files[i].event_id]) {
        result[files[i].event_id] = {
          comment: '',
          files: [],
        }
      }
      result[files[i].event_id].files.push({
        // examination_id: files[i].examination_id,
        component_id: files[i].component_id || null,
        romexis_id: files[i].romexis_id,
      })
    }
    // for (let i = 0; i < result.length; i++) {
    //   result[temp.group_idId][temp.arrIndex].event_id = temp.event_id
    // }
    return result
  }

  const setFilesWithAutocomplete = () => {
    let filesToSet = []
    if (examinationByTypeId) {
      for (let i = 0; i < startFiles.length; i++) {
        let file = Object.assign({}, startFiles[i])
        let examinations = examinationByTypeId[file.type_id]
        if (examinations && examinations.length === 1) {
          file.component_id = examinations[0]
        }
        filesToSet.push(file)
      }
    } else {
      filesToSet = Object.assign([], startFiles)
    }
    let keys = Object.keys(eventsCount)
    if (keys.length > 0) {
      for (let i = 0; i < keys.length; i++) {
        for (let j = 0; j < eventsCount[keys[i]].value; j++) {
          filesToSet.push({
            // examination_id: eventsCount[keys[i]].examination_id,
            romexis_id: Math.random(),
            name: 'Zdjęcie analogowe',
            dap: null,
            component_id: keys[i],
            disabled_component: true,
            group_id: 1,
          })
        }
      }
    }

    setFiles(filesToSet)
  }

  const setDefaultValues = () => {
    let components = data.components
    let object = {}
    let filesByRomexisId = {}
    for (let i = 2; i <= 3; i++) {
      if (allFiles[i]) {
        for (let j = 0; j < allFiles[i].length; j++) {
          filesByRomexisId[allFiles[i][j].romexis_id] = allFiles[i][j]
        }
      }
    }
    for (let i = 2; i <= 3; i++) {
      if (components[i]) {
        for (let j = 0; j < components[i].length; j++) {
          if (components[i][j].romexis_id) {
            let file = filesByRomexisId[components[i][j].romexis_id]
            if (!object[file.type_id]) {
              object[file.type_id] = []
            }
            object[file.type_id].push(components[i][j].id)
          }
          // object[components]
        }
      }
    }
    setExaminationByTypeId(object)
  }

  const setContractTypes = (types) => {
    let object = {}
    for (let i = 0; i < types.length; i++) {
      object[types[i].id] = types[i].name
    }
    setContractTypesNames(object)
    _setContractTypes(types)
  }

  const buildComments = (f) => {
    let c = []
    for (let i = 0; i < f.length; i++) {
      let eventId = f[i].event_id
      if (eventId) {
        c[eventId] = comments[eventId] || ''
      }
    }
    setComments(c)
  }
  const setComment = (index, value) => {
    let c = Object.assign([], comments)
    c[index] = value
    setComments(c)
  }

  const setFileValue = (index, label, value) => {
    let temp = Object.assign([], files)
    let file = Object.assign({}, temp[index])
    file[label] = value
    temp[index] = file
    setFiles(temp)
    if (label == 'event_id') {
      buildComments(temp)
    }
  }

  const setEventId = (value) => {
    let temp = Object.assign([], files)
    let keys = Object.keys(files)
    for (let i = 0; i < keys.length; i++) {
      let file = Object.assign({}, temp[keys[i]])
      file.event_id = value
      temp[keys[i]] = file
    }
    setFiles(temp)
    buildComments(temp)
  }

  const [contractTypes, _setContractTypes] = useState([])
  const [contractTypesNames, setContractTypesNames] = useState({})

  const loadContractTypes = () => {
    return new Promise(function (resolve) {
      axios.post('/lookups/contract_types', null).then((res) => {
        resolve(res.data)
      })
    })
  }

  const randomId = Math.random()

  const submit = async () => {
    setLoading(true)
    await setValidate(true)
    let elements
    setTimeout(() => {
      elements = document.querySelectorAll(
        '.Mui-error .MuiOutlinedInput-notchedOutline'
      )
    }, 100)
    setTimeout(() => {
      if (elements.length == 0) {
        setSweetAlert(true)
      } else {
        setLoading(false)
      }
    }, 200)
  }

  const finalize = () => {
    axios
      .post(`/contracts/${data.id}/finish`, {
        ...data,
        events: parseFilesToSend(files),
      })
      .then((res) => {
        if (res.status == 200) {
          dispatch(closePopup('contract-factory-popup'))
          dispatch(closePopup('events-factory-popup'))
          refreshFilter('ContractsKey')
        }
        setLoading(false)
        handleOpenAlert({
          title: 'Sukces!',
          subtitle: 'Sfinalizowano zlecenie!',
          type: 'success',
        })
      })
      .catch((err) => {
        setLoading(false)
        handleOpenAlert(err.request.status)
      })
  }

  return (
    <>
      <DialogContent dividers={true}>
        <Grid>
          <InputLabel>Ustaw wszystkim badanie</InputLabel>

          <Select onChange={(e) => setEventId(e.target.value)}>
            {contractTypes &&
              contractTypes.map((option, index) => (
                <MenuItem key={option.id + '_' + index} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
          </Select>
        </Grid>
        <Table id="events-factory-table">
          <TableHead>
            <TableRow>
              <TableCell>Zdjęcie</TableCell>
              <TableCell>Badanie</TableCell>
              <TableCell>Zdarzenie</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {files &&
              files.map((file, index) => (
                <TableRow key={file.romexis_id + '-' + randomId}>
                  <TableCell>
                    {file.name} {file.dap && <span>- {file.dap}</span>}
                  </TableCell>
                  <TableCell>
                    <FormControl
                      fullWidth
                      error={validate && !file.component_id}
                    >
                      <Select
                        value={file.component_id}
                        disabled={!!file.disabled_component}
                        onChange={(e) =>
                          setFileValue(index, 'component_id', e.target.value)
                        }
                      >
                        {data.components[file.group_id] &&
                          data.components[file.group_id].map((option) => (
                            <MenuItem
                              key={option.id + '-' + index}
                              value={option.id}
                            >
                              {option.examination_name}
                              {option.tooth1 && <span>- {option.tooth1}</span>}
                            </MenuItem>
                          ))}
                      </Select>
                      {validate && !file.component_id && (
                        <FormHelperText>Badanie jest wymagane</FormHelperText>
                      )}
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <FormControl fullWidth error={validate && !file.event_id}>
                      <Select
                        value={file.event_id}
                        onChange={(e) =>
                          setFileValue(index, 'event_id', e.target.value)
                        }
                      >
                        {contractTypes &&
                          contractTypes.map((option) => (
                            <MenuItem
                              key={option.id + '-' + index}
                              value={option.id}
                            >
                              {option.name}
                            </MenuItem>
                          ))}
                      </Select>
                      {validate && !file.event_id && (
                        <FormHelperText>
                          Typ zdarzenia jest wymagany
                        </FormHelperText>
                      )}
                    </FormControl>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <Box>
          {files &&
            comments.map((comment, typeId) => (
              <FormControl fullWidth key={typeId} style={{ padding: '10px' }}>
                <Typography variant="subtitle1" component="div">
                  Komentarz do zdarzenia: {contractTypesNames[typeId]}
                </Typography>
                <TextareaAutosize
                  style={{ minHeight: '50px' }}
                  placeholder="Komentarz..."
                  value={comment}
                  onChange={(e) => setComment(typeId, e.target.value)}
                />
              </FormControl>
            ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          color="primary"
          type="submit"
          onClick={() => submit()}
          loading={loading}
          loadingPosition="start"
        >
          Zapisz
        </LoadingButton>
      </DialogActions>
      {sweetAlert && (
        <Confirmation
          level={5}
          maxWidth="xs"
          icon="Warning"
          title={`Czy na pewno chcesz dodać zlecenie?`}
          subtitle={`Ta operacja nie jest odwracalna.`}
          reject={() => {
            setSweetAlert(false)
          }}
          success={async () => finalize()}
        />
      )}
    </>
  )
}

EventsFactory.propTypes = {
  startFiles: PropTypes.array,
  data: PropTypes.object,
  examinations: PropTypes.object,
  allFiles: PropTypes.object,
  eventsCount: PropTypes.object,
}

export default EventsFactory
